const ServerKey = "prod";

const BuildConfig = {
  local: {
    cleverLoginUrl: "https://clever.com/oauth/instant-login?client_id=5335289d8b8022081278&district_id=6238639f740ab98db0325ea7",
    baseUrl: "http://my.local.com/srckazoo/api/",
    imageUrl: "/images/",
    baseName: "/kazoobadoo/",
    webflowUrl: "https://kazoobadoo-f637346e2715178c3f01f020dd5d.webflow.io/",
    stripeKey: "pk_test_51JMSHnSDrc8yfWfCOPuWlnLEybDZ2AyGui2sP0EmSJhkJKyxtXBpwX4jSBLSPwOwcKM6xX1dli0fgznuDSqDcOw500mUmgRs4A",
    cleverLogoutUrl: "https://clever.com/logout",
    cleverPortalUrl: "https://clever.com/in/comfortable-blackboard-8374"
  },
  dev: {
    cleverLoginUrl: "https://clever.com/oauth/authorize?response_type=code&redirect_uri=http://kaazooapi.namoncraze.com/users/cleverAuthorize&client_id=8f1404ecb5751afd6a13",
    baseUrl: "http://kaazooapi.namoncraze.com/",
    imageUrl: "/images/",
    baseName: "/",
    webflowUrl: "https://kazoobadoo-f637346e2715178c3f01f020dd5d.webflow.io/",
    stripeKey: "pk_test_51JMSHnSDrc8yfWfCOPuWlnLEybDZ2AyGui2sP0EmSJhkJKyxtXBpwX4jSBLSPwOwcKM6xX1dli0fgznuDSqDcOw500mUmgRs4A",
    cleverLogoutUrl: "https://clever.com/logout",
    cleverPortalUrl: "https://clever.com/in/detailed-school-7979"
  },
  prod: {
    cleverLoginUrl: "https://clever.com/oauth/authorize?response_type=code&redirect_uri=https://api.kazoobadoo.com/users/cleverAuthorize&client_id=8290a5acb1da7e71918f&district_id=62085667db8884fb83c4e75a",
    baseUrl: "https://api.kazoobadoo.com/",
    gameBaseUrl: "https://api.kazoobadoo.com/WebGL/index.html",
    imageUrl: "/images/",
    baseName: "/",
    webflowUrl: "https://portal.kazoobadoo.com/",
    stripeKey: "pk_test_51NXi93SJXFXbPHapiP2KCaVpnmv6BS10L1uGkOWulUoPasxwojwK7BatFL24ewrbHxH6YP5HtNPuOJhvDLI7jwEP0069zvOVpX",
    cleverLogoutUrl: "https://clever.com/logout",
    cleverPortalUrl: "https://clever.com/in/kazoobadoo"
  },
};

export const baseUrl = BuildConfig[ServerKey].baseUrl;
export const gameBaseUrl = BuildConfig[ServerKey].gameBaseUrl;
export const imageUrl = BuildConfig[ServerKey].imageUrl;
export const baseName = BuildConfig[ServerKey].baseName;
export const webflowUrl = BuildConfig[ServerKey].webflowUrl;
export const stripeKey = BuildConfig[ServerKey].stripeKey;
export const cleverUrl = BuildConfig[ServerKey].cleverLoginUrl;
export const cleverLogoutUrl = BuildConfig[ServerKey].cleverLogoutUrl;
export const cleverPortalUrl = BuildConfig[ServerKey].cleverPortalUrl;

export const ImageList = [
  {
    id: "shirt_out",
    path: "shirt_outside_preview.svg",
    left: 65,
    top: 203,
    excludeKey: "outfit",
    index: 1,
    width: 120,
    height: 46,
  },
  {
    id: "neck_out",
    path: "neck_outline_preview.svg",
    left: 111,
    top: 183,
    excludeKey: "skinColor",
    index: 0,
    width: 27,
    height: 29,
  },
  {
    id: "head",
    path: "head_outline_preview.svg",
    left: 53,
    top: 44,
    excludeKey: "skinColor",
    index: 1,
  },
  {
    id: "mouth",
    path: "mouth_preview.svg",
    left: 102,
    top: 148,
    excludeKey: "mouth",
    index: 4,
  },
  {
    id: "eyes",
    path: "eyes_preview.svg",
    left: 94,
    top: 107,
    excludeKey: "eyes",
    index: 4,
  },
  {
    id: "nose",
    path: "nose_preview.svg",
    left: 123,
    top: 127,
    excludeKey: "nose",
    index: 4,
  },
  {
    id: "ears",
    path: "ears_outline_preview.svg",
    left: 42,
    top: 112,
    excludeKey: "skinColor",
    index: 4,
  },
];

export const ColoredImages: any = {
  hairColor: {
    id: "shirt",
    path: "shirt_preview.svg",
    left: 65,
    top: 203,
    excludeKey: "outfit",
  },
};
